/**
 * 钱包特殊跳转
 * 适用于随手记
 */
define('util/client-requestWalletBackToProductList',['util/client-bridge',
    'util/client-version',
    'util/client-refreshMain',
    'util/client-closeView'],
    function(clientBridge, clientVersion, clientRefreshMain, clientCloseView, clientJumpto) {
    return function() {
        if (CLIENT_DATA.client === 'ssj') {
            var featureVersion = (CLIENT_DATA.os === 'android') ? '10.2.5.0' : '10.4.6';
            // 版本比较
            if (clientVersion.compare(featureVersion)) {
                clientBridge.call(clientBridge.uriSuishouji('requestWalletBackToProductList'));
            } else {
                clientRefreshMain();
                clientCloseView();
            }
        } else if (CLIENT_DATA.client === 'sgj') {
          clientBridge.call('sgj://launch.ssjlicai.com?p=INDEX_PAGE');
        } else  {
            window.location.href = '/public-vue/product/index.html#/wallet';
        }
    };
});

